module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Y5BB"))).then(() => parcelRequire('1iHdE'));